import { SxProps } from '@mui/material'

interface BannerSearchStyles {
  searchPlaceHolder: SxProps
  searchPlaceHolderActive: SxProps
  searchIcon: SxProps
  searchInput: SxProps
  dropdownContentWrapper: SxProps
  noDataText: SxProps
  mobileModal: {
    root: SxProps
    header: SxProps
    searchIcon: SxProps
    input: SxProps
    closeBtn: SxProps
    closeBtnText: SxProps
    body: SxProps
  }
}

export const bannerSearchStyles: BannerSearchStyles = {
  searchPlaceHolder: {
    height: {
      xs: 52,
      lg: 68,
    },
    width: '100%',
    borderRadius: 1.5,
    backgroundColor: 'background.default',
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1.5,
    position: 'relative',
  },
  searchPlaceHolderActive: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  searchIcon: {
    color: 'text.quaternary500',
    width: 20,
    height: 20,
  },
  searchInput: {
    width: '100%',
  },
  dropdownContentWrapper: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: 'background.default',
    maxHeight: { xs: 250, md: 400 },
    overflowY: 'auto',
    p: 0,
  },
  noDataText: {
    px: 2,
    py: 1,
    typography: 'textSmMedium',
    fontStyle: 'italic',
    color: 'text.secondary700',
  },
  mobileModal: {
    root: {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      p: 2,
      borderBottom: '1px solid',
      borderColor: 'border.secondary',
      justifyContent: 'space-between',
    },
    searchIcon: {
      color: 'text.quaternary500',
      width: 16,
      height: 16,
      mt: -0.25,
    },
    input: {
      flex: 1,
    },
    closeBtn: {
      typography: 'textSmMedium',
      color: 'text.primary900',
      p: 1,
    },
    closeBtnText: {
      typography: 'textSmMedium',
    },
    body: {
      flex: 1,
      overflowY: 'auto',
    },
  },
}
